import * as React from 'react';
import cn from 'classnames';

import { CardExtraView, CardExtraViewAggregator, CardExtraIcon } from '@shared/ui';
import { ServiceType } from '../../../../CardExtra/types';
import { useTheme } from '../../../../theme';
import CommonContent, { Props as CommonContentProps } from '../CommonContent';
import { CardExtraViewVariant } from '@shared/ui/CardExtraView';

export interface ServiceCardBaseProps extends CommonContentProps {
	className?: string;
	mode?: CardExtraViewVariant;
}

interface Props extends ServiceCardBaseProps {
	type: ServiceType;
	title: React.ReactNode;
	description?: React.ReactNode;
}

const ServiceCard: React.FC<Props> = ({
	mode = 'default',
	type,
	className,
	title,
	description,
	getServiceName,
	...commonContentProps
}) => {
	const theme = useTheme('RefundSummary').CommonContent;
	const content = <CommonContent {...commonContentProps} getServiceName={getServiceName} />;

	const cardProps = {
		type,
		title,
		description,
		classes: {
			root: cn(theme.serviceCard, className),
			header: theme.serviceCard_header,
			header__icon: theme.serviceCard_header__icon,
			content: theme.serviceCard_content,
			footer: theme.serviceCard_footer
		},
		icon: <CardExtraIcon type={type} />,
		content
	};

	if (mode === 'aggregator') {
		return <CardExtraViewAggregator {...cardProps} />;
	}

	return <CardExtraView {...cardProps} />;
};

export default ServiceCard;
